import createSvgIcon from '@mui/material/utils/createSvgIcon';

const DbGovernance = createSvgIcon(
  <svg
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2H45C45.5523 2 46 2.44772 46 3V45C46 45.5523 45.5523 46 45 46H3C2.44772 46 2 45.5523 2 45V3C2 2.44772 2.44772 2 3 2ZM0 3C0 1.34315 1.34315 0 3 0H45C46.6569 0 48 1.34315 48 3V45C48 46.6569 46.6569 48 45 48H3C1.34315 48 0 46.6569 0 45V3ZM10.5 21C9.94772 21 9.5 21.4477 9.5 22V42H14.5V22C14.5 21.4477 14.0523 21 13.5 21H10.5ZM21.5 12C21.5 11.4477 21.9477 11 22.5 11H25.5C26.0523 11 26.5 11.4477 26.5 12V42H21.5V12ZM34.5 17C33.9477 17 33.5 17.4477 33.5 18V42H38.5V18C38.5 17.4477 38.0523 17 37.5 17H34.5Z"
    />
  </svg>,
  'DbGovernance')

export default DbGovernance;
